import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue';
Vue.config.productionTip = false;
Vue.config.optionMergeStrategies.render = (parentRenderer, childRenderer) => {
  if (parentRenderer && parentRenderer.length == 2) {
    // parentRenderer.length == 2：
    // 使用此 render 合并策略，则需要重写父级组件的 render 实现，如：
    //
    // render(createElement, children) {
    //   return createElement(
    //     "div",
    //     {
    //       class: 'fill-in app-wrapper ' + this.siteRenderer
    //     },
    //     [ createElement(Global), ...children ]
    //   )
    // }
    return function render(...args) {
      args.push([childRenderer.apply(this, args)]);
      return parentRenderer.apply(this, args);
    }
  }
  return childRenderer || parentRenderer;
}

import VueCookies from 'vue-cookies'
import siteOptions from '@/config/index'
import api from "@/framework/ajax/index";
import apiConfig from "@/ajax/index";
import Global from '@/framework/components/Global'
import { enableTracker } from '@/framework/utils/ticker.js'
import { getAppRouter } from '@/framework/utils/router.js'
import { connectToOtherPassport } from "@/framework/utils/tools";
import { renderWatermark, initDocumentTitle } from '@/framework/utils/layout'

// 引入 element-ui.
import ElementUI from 'element-ui';
// 引入业务组件
import BusinessUI from '@/components'
import frameworkModule from '@/framework/store'

// 引入框架样式
const theme = localStorage.getItem('fav-theme') || siteOptions['theme'] || 'default'
// TODO: 此处不可用 import ??
// require ('@/framework/styles/themes/' + theme + '.scss');

import style from '@/framework/styles/themes/default.scss'
import { Notification } from "element-ui";


let initApp = (params)=>{
	// 站点标题
	initDocumentTitle()
	// 埋点处理.
	if(siteOptions['isTrackUser']){
	  enableTracker()
	}
	Vue.use(ElementUI, {
	  size: 'medium'  // 组件的全局尺寸.
  })
  Vue.use(BusinessUI);
  // 加载 cookies 插件
  Vue.use(VueCookies);
  
	// 加载 ajax 接口.
	api.load(apiConfig);

	// 全局 event bus.
	window._dc = window._event_bus = new Vue()

	const router = getAppRouter(params['router'])

  const store = params['store']
  store.registerModule('framework', frameworkModule)
  
  // // 鉴权处理
  // const { userInfo = {} } = store.getters;

  router.beforeEach(async(to, from, next) => {
    await store.dispatch('getUserInfo');
    const { userInfo = {} } = store.getters;
    connectToOtherPassport(userInfo.tickets);
    const {showMenu, isShowPurchase} = userInfo;
    if(!(showMenu && isShowPurchase) && to.path === "/products/iframe/") {
      Notification.warning({
        title: "提示",
        message: "没有该菜单权限，跳转失败"
      })
      next(from.path);
    } else {
      next();
    }
  })

	return {
		el: '#app',
		router,
		store,
    computed: {
			...mapGetters([
        'siteRenderer',
        'isMenuCollapsed'
    	])
    },
		mounted() {
	    renderWatermark()
	  },
    methods: {
      ...mapActions([
	      'setMenuCollapsedState',
	    ])
    },
		render(createElement, children) {
      return createElement(
        "div",
        {
          class: 'fill-in app-wrapper ' + this.siteRenderer
        },
        [ createElement(Global), ...children ]
      )
    }
	}
}

export {
	initApp
}
